// Module
var code = "<template> <div dt-grid-container> <div dt-grid-row> <div dt-grid-col=\"s:12\"> <h2>${'persons.edit.header' & t}</h2> <require from=\"persons/person-edit-form\"></require> <person-edit-form person-id.bind=\"personId\" submit-label.bind=\"'persons.edit.submitButton' & t\"></person-edit-form> </div> </div> </div> </template> ";
// Exports
export default code;